import { useState } from 'react';

import ConfirmationDialog from 'domains/core/components/ConfirmationDialog';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import InfoSnackbar from 'domains/core/components/Snackbars/InfoSnackbar';
import SuccessSnackbar from 'domains/core/components/Snackbars/SuccessSnackbar';
import { Segment } from 'domains/segments/types';
import useUnarchiveSegmentItem from 'hooks/useUnarchiveSegmentItem';
import { Folder } from 'models/types';

type Props = {
    activeItem: Segment | Folder;
    handleModalClose: () => void;
    isOpen: boolean;
    refetchTableData: () => void;
    resetActiveItem: () => void;
};

const UnarchiveSegmentItemModal = ({
    activeItem,
    handleModalClose,
    isOpen,
    refetchTableData,
    resetActiveItem,
}: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const { getUnarchiveItemFunction, isLoading, isSuccess } = useUnarchiveSegmentItem({
        activeItem,
        refetchTableData,
        resetActiveItem,
        setErrorMessage,
        setSuccessMessage,
    });

    const handleUnarchive = () => {
        const unarchiveItem = getUnarchiveItemFunction();
        unarchiveItem();
        handleModalClose();
    };

    const onCancel = () => {
        handleModalClose();
        resetActiveItem();
    };

    const infoMessage = `Unarchiving "${activeItem?.name}"`;
    const contentText = `You are about to unarchive "${activeItem?.name}." This will move the item back to the main list.`;
    const title = `Unarchive ${activeItem?.type}`;

    return (
        <>
            {errorMessage && <ErrorSnackbar errorMessage={errorMessage} />}
            {isLoading && <InfoSnackbar successMessage={infoMessage} />}
            {isSuccess && <SuccessSnackbar successMessage={successMessage} />}
            <ConfirmationDialog
                dialogProps={{
                    confirmButtonText: 'Unarchive',
                    contentText,
                    title,
                }}
                onCancel={onCancel}
                onConfirm={handleUnarchive}
                onModalClose={handleModalClose}
                open={isOpen}
            />
        </>
    );
};

export default UnarchiveSegmentItemModal;
